module.exports = __webpack_public_path__ + "img/icon4.f4f29e19.png";